import { generateCriticalNoCallMessage } from '../blurbs';

import type { ICriticalNoCallValues, IUseCriticalNoCallProps } from '../types';

export const useCriticalNoCall = ({
  addComment,
  readingType,
  closeModal,
  handleSubmit,
}: IUseCriticalNoCallProps) => {
  const initialValues: ICriticalNoCallValues = {
    isCallIndicated: null,
    whyNotIndicated: [],
    whyNotIndicatedText: null,
    whoAttemptedCall: [],
    attemptOutcome: null,
    isReadingEscalated: null,
    escalatedVia: [],
    escalatedReasons: [],
    notEscalatedReasons: [],
    notEscalatedReasonsOther: '',
    escalatedViaOther: null,
    readingTypeText: readingType,
  };

  const preparedData = (data: ICriticalNoCallValues) => {
    return {
      readingTypeText: data.readingTypeText,
      isCallIndicated: data.isCallIndicated,
      whyNotIndicated: data.whyNotIndicated,
      whyNotIndicatedText: data.whyNotIndicatedText,
      whoAttemptedCall: data.whoAttemptedCall,
      attemptOutcome: data.attemptOutcome,
      isReadingEscalated: data.isReadingEscalated,
      escalatedVia: data.escalatedVia,
      escalatedReasons: data.escalatedReasons,
      notEscalatedReasons: data.notEscalatedReasons,
      notEscalatedReasonsOther: data.notEscalatedReasonsOther,
      escalatedViaOther: data.escalatedViaOther,
    };
  };

  const onSaveForm = (formData: ICriticalNoCallValues) => {
    const preparedValues = preparedData(formData);
    const message = generateCriticalNoCallMessage(preparedValues);

    handleSubmit(message);
    addComment(message);
    closeModal();
  };

  return {
    initialValues,
    onSaveForm,
  };
};
